import { render, staticRenderFns } from "./myProDetail.vue?vue&type=template&id=f4a2db0c&scoped=true&"
import script from "./myProDetail.vue?vue&type=script&lang=js&"
export * from "./myProDetail.vue?vue&type=script&lang=js&"
import style0 from "./myProDetail.vue?vue&type=style&index=0&id=f4a2db0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a2db0c",
  null
  
)

export default component.exports